import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
// Stage 5E.1 — Ordly platform theme. Synchronously seeds Classic
// onto :root before App mounts; fires off the public /api/ordly-theme
// fetch immediately so any active non-Classic preset replaces the
// values as soon as the network round-trip returns.
import { refreshOrdlyTheme } from "@/lib/ordlyTheme";

// Phase 16 Stage 5C — build-time marker so the Preview smoke can
// assert ON/OFF builds via DOM observation. The value is inlined by
// CRACO/Webpack at compile time from the .env file; flipping the
// runtime variable WITHOUT restarting the dev server has no effect
// on this marker (which is the entire point — see Stage 5C plan
// revision 2.1).
if (typeof window !== "undefined") {
  window.ORDLY_BUILD_COBRANDED_SHELL =
    process.env.REACT_APP_COBRANDED_COMPANY_SHELL_ENABLED === "true";
  // Stage 5D — Accountant Workspace build marker.
  window.ORDLY_BUILD_COBRANDED_ACCOUNTANT_SHELL =
    process.env.REACT_APP_COBRANDED_ACCOUNTANT_SHELL_ENABLED === "true";
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// Kick off the Ordly theme refresh in parallel with React mount; the
// promise is intentionally not awaited so we never delay paint.
refreshOrdlyTheme();
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
